/* istanbul ignore file */
import React from 'react';
import BudgetBreadcrumbs from 'domain/finance/budget/shared/BudgetBreadcrumbs';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const CreateBudgetBreadcrumbs = () => {
  return (
    <BudgetBreadcrumbs>
      <CreateBreadcrumbItem entity="Budget" />
    </BudgetBreadcrumbs>
  );
};

export default CreateBudgetBreadcrumbs;
